angular.module('core')
  .factory('storage', ['sock', function (sock) {
    var storage = {
      get: function (key, cb) {
        sock.send('getData', key, cb);
      },
      set: function (key, value, cb) {
        sock.send('setData', { key: key, value: value }, cb);
      }
    };

    return storage;
  }]);
